// extracted by mini-css-extract-plugin
export default {"subTitle":"JP_Location_subTitle__om+om","boxContent":"JP_Location_boxContent__Uktuz","backgroundImg":"JP_Location_backgroundImg__tMRPT"};